import { ImageSource } from 'expo-image';

import BettyBoxLocked from './betty-box-locked.webp';
import BettyBoxLockedRotating from './betty-box-locked-rotating.webp';
import Cash from './cash.webp';
import Coin from './coin.webp';
import Wheel from './wheel.webp';
import Spins from './freespins.webp';
import GiftBox from './giftbox.webp';
import Jackpot from './jackpot.webp';
import LevelUp from './levelup.webp';
import Megaphone from './megaphone.webp';
import BettyCoinStack from './betty-coin-stack.webp';
import BettyPiggy from './betty-piggy.webp';
import BettyWheel from './betty-wheel.webp';
import GreenCheck from './green-check.webp';
import error from './error.webp';
import pending from './pending.webp';
import rejected from './rejected.webp';
import success from './success.webp';
import LimitReachedClock from './limit-reached-clock.webp';
import TimerClock from './clock.webp';
import Hourglass from './hourglass.webp';
import Clock from './clock-blue-red.webp';
import FallingCoins from './betty-coin-falling.webp';
import BettyNotification from './betty-notification.webp';
import Interac from './interac.webp';
import BettyBadge from './betty-badge.webp';
import check from './check.webp';
import Documents from './documents.webp';
import RotatingCoin from './rotating-coin.webp';
import homePageBackground from './home-page-background.webp';

import { registerImages } from './registry';

const images = {
  BettyBoxLocked,
  BettyBoxLockedRotating,
  Cash,
  Coin,
  Wheel,
  Spins,
  GiftBox,
  Jackpot,
  LevelUp,
  Megaphone,
  BettyCoinStack,
  BettyPiggy,
  BettyWheel,
  GreenCheck,
  error,
  pending,
  rejected,
  success,
  LimitReachedClock,
  TimerClock,
  Hourglass,
  Clock,
  FallingCoins,
  BettyNotification,
  Interac,
  BettyBadge,
  check,
  Documents,
  RotatingCoin,
  homePageBackground,
};

declare global {
  interface RegisteredImages {
    common: Record<keyof typeof images, ImageSource>;
  }
}

registerImages('common', images);

export { getImages } from './registry';
